import { render } from "./Dashboard.vue?vue&type=template&id=8c56d636&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=8c56d636&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=8c56d636&lang=css"
script.render = render
script.__scopeId = "data-v-8c56d636"

export default script